export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://readdy.ai/api/search-image?query=modern%20minimalist%20tech%20logo%20design%20for%20code%20linter%20tool%20featuring%20abstract%20geometric%20shapes%20with%20cyan%20and%20purple%20gradient%20colors%2C%20clean%20lines%2C%20circular%20or%20hexagonal%20form%20representing%20unity%20and%20connection%2C%20professional%20software%20development%20brand%20identity%2C%20simple%20icon%20on%20transparent%20or%20dark%20background%2C%20vector%20style%20illustration&width=120&height=120&seq=bellibutton-logo-v2&orientation=squarish" 
                alt="Bellibutton Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-white text-xl font-mono font-bold">bellibutton</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm">
              Universal lint rule management for modern development teams. One source of truth for all your projects.
            </p>
            <div className="flex gap-3">
              <a
                href="https://github.com/yeswayjosue/bellibutton"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center hover:bg-white/10 hover:border-[#00d9ff]/50 transition-all cursor-pointer"
              >
                <i className="ri-github-fill text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center hover:bg-white/10 hover:border-[#00d9ff]/50 transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center hover:bg-white/10 hover:border-[#00d9ff]/50 transition-all cursor-pointer"
              >
                <i className="ri-discord-line text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('documentation')}
                  className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer"
                >
                  Documentation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('usage')}
                  className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer"
                >
                  Usage
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer">
                  Integrations
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer">
                  Community
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer">
                  Support
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer">
                  API Reference
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <a href="https://github.com/yeswayjosue/bellibutton" className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer">
                  GitHub
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('license')}
                  className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer"
                >
                  License
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-[#00d9ff] transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2024 Bellibutton. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-500 hover:text-[#00d9ff] text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-[#00d9ff] text-sm transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-500 hover:text-[#00d9ff] text-sm transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
